<template>
    <div class="page wallet">
        <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
        <pageTitle title='银联券明细'></pageTitle>
        <div class="mycoin">
            我的银联券
            <h2>￥{{wallet.UnionPayCash}}</h2>
        </div>
        <div class="demo-refresh-container">
            <div class="list">
                <div class="item" v-for="item in coinRecords">
                    <div class="date">
                        {{item.operateDate | detailDate}}
                    </div>
                    <div>
                        <span class='strong'>{{item.moneyOperateComent}}</span><br/>
                        <span class='detail'>备注:{{item.data | remark }}</span>
                    </div>
                    <div>
                        <span class='num'>{{item.operateMoney | discount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <loadListTail mainTitle='暂无银联账户记录' mainIcon='noDetail' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='coinRecords.length > 0'  />
        <div class='loading' v-if='loadState.loading'>
            <img src="../../../static/LoadingBest.gif" />
        </div>
    </div>
</template>

<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import Scroll from '../../utils/loading'
import loadListTail from '../../components/loadListTail'

export default {
  data () {
    return {
        coinRecords:[],
        loadState:'',
        refreshing: false,
        trigger: null,
        scroll:null,
    }
  },
  components:{
    loadListTail
  },
  activated(){
    this.scroll.addHandler()
  },
  deactivated(){
    this.scroll.removeHandler()
  },
  mounted(){
    this.trigger = this.$el
    this.scroll = Scroll.Create(this,this.getData,10,1)
  },
  methods: {
    initData(){
        //清空显示数据
        this.coinRecords = []
        //初始化本页控制数据、分页参数
        this.scroll.refresh()
    },
    getData () {
      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex',this.pageParam.index);
      params.append('pageSize', 10);
      params.append('type', 2);
      return new Promise(function(resolve, reject) {
        that.$http.post(api.getCashLog(),params.toParam()).then((res) => {
            if(res.Result){
                var temp = res.Data;
                resolve(temp.length)
                that.coinRecords =that.coinRecords.concat(temp);
            }
            else{
                resolve(null)
                that.$router.push({ path: '/user/Login' })
            }
        }).catch(function (error) {
            reject();
            console.log(error);
        });
      })
    },
    refresh () {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },
  },
  computed:{
      ...mapGetters({
        wallet:'g_walletInfo',loginInfo:'g_loginInfo'
      })
  },
  watch:{ 
    loginInfo: {
        handler: function (val, oldVal) {
            this.initData()
        },
        deep: true
    },
  }
}
</script>


// WEBPACK FOOTER //
// VISADetail.vue?13472680